import {List} from "immutable";
import {getGeoType} from "../../utils/getGeoType";
import {dataLayer, dataLayerLineString, dataLayerPoint} from "./loadMapStyle";
import {Reducer} from "redux";
import {IApplicationState} from "../types";

const selectFeatures: Reducer<IApplicationState['map']|undefined> = (state, action) => {
    let {features} = action.payload;
    let highlightedPoints = List<any>([]);
    let highlightedPolygons = List<any>([]);
    let highlightedLines = List<any>([]);
    if (features && features.length !== 0) {
        const types: any = {};
        let i = - 1;
        while (++i < features.length) {
            const feature = features[i];
            if (!types[feature.type]) {
                types[feature.type] = [feature.fullUid];
            } else {
                types[feature.type].push(feature.fullUid);
            }
        }

        Object.keys(types).forEach(type => {
            const fullUidList = types[type] || [];
            const newFeatures: List<any> = state?.mapStyle
                .getIn(['sources', type, 'data', 'features'])
                .filter((f: any) => fullUidList.indexOf(f.getIn(['properties', 'fullUid'])) !== -1);
            if (newFeatures.size > 0) {
                // const geoType = newFeatures.getIn([0, 'properties', 'geoType']);
                const geoType = getGeoType(newFeatures.getIn([0]).toJS());
                switch (geoType) {
                    case 'Point':
                        highlightedPoints = highlightedPoints.concat(newFeatures) as any;
                        break;
                    case 'Line':
                        highlightedLines = highlightedLines.concat(newFeatures) as any;
                        break;
                    case 'Polygon':
                    default:
                        highlightedPolygons = highlightedPolygons.concat(newFeatures) as any;
                }
            }
        });


    }
    let mapStyle = state?.mapStyle;
    mapStyle = mapStyle?.setIn(['sources', dataLayer.source, 'data', 'features'], highlightedPolygons)
        .setIn(['sources', dataLayerLineString.source, 'data', 'features'], highlightedLines)
        .setIn(['sources', dataLayerPoint.source, 'data', 'features'], highlightedPoints);
    return {...state, mapStyle} as IApplicationState['map'];
}

export { selectFeatures };
